import type {WebappLanguage} from '@cohort/shared/schema/common';
import {WEBAPP_SUPPORTED_LANGUAGES} from '@cohort/shared/schema/common';
import type {ResourceLanguage} from 'i18next';

export async function getAppLocales(
  appName: string
): Promise<Record<WebappLanguage, ResourceLanguage>> {
  const locales: Record<WebappLanguage, ResourceLanguage> = WEBAPP_SUPPORTED_LANGUAGES.reduce(
    (acc, lang) => {
      acc[lang] = {};
      return acc;
    },
    {} as Record<WebappLanguage, ResourceLanguage>
  );
  const importPromises = WEBAPP_SUPPORTED_LANGUAGES.map(
    // eslint-disable-next-line import/dynamic-import-chunkname
    lang => import(`./${appName}/locales/${lang}.json`)
  );
  const translationModules = await Promise.all(importPromises);

  WEBAPP_SUPPORTED_LANGUAGES.forEach((lang, index) => {
    locales[lang] = translationModules[index].default;
  });
  return locales;
}
